import * as _ from "lodash";
import * as Constants from "../common/constants";
import { createWebServiceDataSource } from "../common/data";
import * as Global from "../common/global";
import * as GridUtil from "../common/gridFilter";
import * as UI from "../common/ui";
import * as templateFormData from "../data/templateFormData";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";
import * as Data from "../interfaces/data";

// classes used to display a list of template forms

// parameters for filtering the list
export interface ITemplateFormsListFilter {
    SearchText?: string;
}

export class TemplateFormsController implements IController {
    // private properties

    // controls
    private grid: kendo.ui.Grid;
    private dataSource: kendo.data.DataSource;
    private gridFilterControl: GridUtil.GridFilterControl;

    // references to DOM elements
    private gridContainer: JQuery;

    // public methods

    // outputs the control to the HTML
    // returns a jQuery promise.
    public render(container: JQuery): JQueryPromise<any> {
        const me: TemplateFormsController = this;
        const app: IApplication = Global.app();
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        me.gridContainer = container.find("div[data-id='grid']");

        // create the grid
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });

        // bind to copy form link in the grid
        me.gridContainer.on("click", "a[data-id='copyLink']", function(e: any) {
            e.preventDefault();
            const ID: string | undefined = $(this).attr("href");
            UI.showConfirmDialog("Are you sure you want to copy this form?", () => {

                templateFormData.CopyForm(ID)
                    .done((response: Data.IResponse<number>) => {
                        if (response.Success) {
                            UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                            me.refresh();
                            deferred.resolve();
                        } else {
                            UI.showErrorMessage(response.ErrorMessages);
                            deferred.reject();
                        }
                    })
                    .fail(() => {
                        deferred.reject();
                    });

            });
        });

        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "ID", field: "ID" },
                { title: "Name", field: "FormName", template: kendo.template($("#template_templateforms_formname").html()) },
                { title: "Type", field: "FormTypeName" },
                { title: "Copy Form", template: "<a href=\"#: ID #\" title=\"Open Template\" data-id=\"copyLink\">Copy Form</a>" },
                {
                    title: "Last Modified", field: "DateTimeModified",
                    template: kendo.template($("#template_templateforms_lastmodifieddate").html()),
                },
                { title: "Modified By", field: "ModifedByFullName" },
            ],
            excel: {
                fileName: "FormTemplates.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");

        me.grid.hideColumn(0);
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });

        // bind to all link tags in the grid
        me.gridContainer.on("click", "a[data-id='link']", function(e: any): boolean {
            const path: string | undefined = $(this).attr("href");
            e.preventDefault();
            // open the page
            app.router().navigate(_.defaultTo<string>(path, ""), true);
            return false;
        });

        deferred.resolve();

        return deferred.promise();
    }

    // put data into this control.
    // call after rendering the control
    public load(params: any[]): JQueryPromise<any> {
        const app: IApplication = Global.app();
        const me: TemplateFormsController = this;
        let dataSource: kendo.data.DataSource;
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        dataSource = createWebServiceDataSource(
            "/api/TemplateForms",
            {
                id: "ID",
                fields: {
                    ID: { type: "long" },
                    FormName: { type: "string" },
                    DateTimeModified: { type: "date" },
                    IsActive: { type: "boolean" },
                    FormTypeName: { type: "string" },
                    ModifedByFullName: { type: "string" },
                },
            },
            (data: any) => {
                me.setDataFilter(data);
            },
            (status: number) => {
                if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                    // user is not allowed to view this data, so close the page
                    app.pageManager().closeCurrentPage();
                }
                // for other errors, keep page open, allow user to retry.
            });

        // load data into the grid by calling a web service
        me.grid.setDataSource(dataSource);

        deferred.resolve();
        return deferred.promise();
    }

    public add(): void {
        Global.app().router().navigate("/TemplateForm", true);
    }

    public haveFieldsChanged(): boolean {
        // no editable fields
        return false;
    }

    public height(height: number): void {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    }

    // called when loaded page is redisplayed
    public refresh(): void {
        this.grid.dataSource.read();
    }

    // returns a unique ID for the control, so it can be redisplayed if
    // already open.  Used by the AppRouter class.
    public appRouterID(params: string[]): string {
        return "FormTemplates";
    }

    // returns a title for the page
    public title(): string {
        return "Form Templates";
    }

    public subTitle(): string {
        return "";
    }

    private setDataFilter(data: any): void {
        data.IncludeActive = true;
        data.IncludeInactive = false;

        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/templateForms.ts